import type { ShapeType } from '../../../utils/parseIngredients'
import { SHAPE_LABELS, type ShapeValue } from '../shapeValue'

interface ShapeFieldsetProps {
  /** Заголовок блока: «Исходная форма» / «Ваша форма». */
  title: string
  value: ShapeValue
  onChange: (value: ShapeValue) => void
}

const SHAPE_TYPES: ShapeType[] = ['circle', 'square', 'rectangle']

/** Блок ввода одной формы: тип, размеры сторон и высота. */
const ShapeFieldset = ({ title, value, onChange }: ShapeFieldsetProps) => {
  const set = (patch: Partial<ShapeValue>) => onChange({ ...value, ...patch })

  // Размеры прошлого типа сбрасываем: иначе «сторона A» от квадрата осталась бы
  // в расчёте круга и коэффициент посчитался бы по старым данным.
  const setType = (type: ShapeType) =>
    set({ type, diameter: '', sideA: '', sideB: '' })

  return (
    <section className="shape-calc-fieldset">
      <h2 className="shape-calc-fieldset__title">{title}</h2>

      <div className="shape-calc-types">
        {SHAPE_TYPES.map(type => (
          <button
            key={type}
            type="button"
            className={`shape-calc-type ${value.type === type ? 'active' : ''}`}
            onClick={() => setType(type)}
          >
            {SHAPE_LABELS[type]}
          </button>
        ))}
      </div>

      <div className="shape-calc-inputs">
        {value.type === 'circle' && (
          <label className="shape-calc-field">
            <span>Диаметр, см</span>
            <input
              type="number"
              inputMode="decimal"
              value={value.diameter}
              onChange={e => set({ diameter: e.target.value })}
              placeholder="16"
            />
          </label>
        )}

        {value.type === 'square' && (
          <label className="shape-calc-field">
            <span>Сторона, см</span>
            <input
              type="number"
              inputMode="decimal"
              value={value.sideA}
              onChange={e => set({ sideA: e.target.value })}
              placeholder="18"
            />
          </label>
        )}

        {value.type === 'rectangle' && (
          <>
            <label className="shape-calc-field">
              <span>Сторона A, см</span>
              <input
                type="number"
                inputMode="decimal"
                value={value.sideA}
                onChange={e => set({ sideA: e.target.value })}
                placeholder="12"
              />
            </label>
            <label className="shape-calc-field">
              <span>Сторона B, см</span>
              <input
                type="number"
                inputMode="decimal"
                value={value.sideB}
                onChange={e => set({ sideB: e.target.value })}
                placeholder="32"
              />
            </label>
          </>
        )}

        <label className="shape-calc-field">
          <span>Высота, см</span>
          <input
            type="number"
            inputMode="decimal"
            value={value.height}
            onChange={e => set({ height: e.target.value })}
            placeholder="8"
          />
        </label>
      </div>
    </section>
  )
}

export default ShapeFieldset
